import { createApp } from 'vue';
import './style.css';
import '@/style/apos.css';
import '@/style/global.css';
import 'vuetify/styles';
import 'element-plus/dist/index.css';
import "vue-awesome-paginate/dist/style.css";
import '@mdi/font/css/materialdesignicons.css';
import App from './App.vue';
import router from "@/router/router.js";
import ElementPlus from 'element-plus';
import VueAwesomePaginate from "vue-awesome-paginate";
import { createHead } from '@vueuse/head';


import { createVuetify } from 'vuetify';
import { VDateInput } from 'vuetify/labs/VDateInput'

import * as components from 'vuetify/components';
import * as directives from 'vuetify/directives';
import {createPinia} from "pinia";

// Create Pinia instance
const pinia = createPinia();

// Create Vuetify instance
const vuetify = createVuetify({
    components: {
        ...components,
        VDateInput,
    },
    directives,
});

const head = createHead();


const app = createApp(App)
    .use(router)
    .use(ElementPlus)
    .use(vuetify)
    .use(pinia)
    .use(head)
    .use(VueAwesomePaginate)


router.isReady().then(() => {
    app.mount('#app');
});
